// extracted by mini-css-extract-plugin
export default {"root":"gVo7hrW9ntyWk7PQN8pU","scroll":"cUg0TSBCG2KkulQKbIfb","cards":"MakAhifmia7s8OeknRmq","stub":"lpou8v0xDmQSfKplDaxK","placeHolderShimmer":"a7Tmtww7plz7MV_1w36I"};